import store_config from "@/store/mods/parametres/config"
import $ from 'jquery'
import ManageModeleExamen from '@/views/parametres/configs/param-modele-examen/manage-modele-examen'

export default {
    name: 'liste-champs-modele-examen',
    components: {
        ManageModeleExamen
    },
    props: {
        user_info: Object,
        active_role: Object,
        selected_examen: Object,
        selected_modele: Object,
    },
    data() {
        return {
            liste_champs: [],
            liste_champ_empty: false,
            liste_champ_loading: true,
            is_error: false,

            fields: [
				'champ', { key: 'type_champ', label: 'Type de champ' }, 'occurences', 'statut',
                { key: 'actions', label: 'Action.s' }
			],
			filter_champ: "",
			perPage: -1,
			currentPage: 1,
            champ_to_edit: {},
            mdl_toggler: 0,
            is_edit: false,
        }
    },

    computed: {

    },

    mounted() {
        this.getListeChampsModele()
    },

    methods: {
        getListeChampsModele() {
            this.liste_champ_loading = true
            const data = {
                modele_examen_id: this.selected_modele.id
            }
            store_config.getListeChampByModeleExamen(data).then((response) => {
                this.liste_champs = response
                if (response.length == 0) {
                    this.liste_champ_empty = true
                } else {
                    this.liste_champ_empty = false
                }
                this.liste_champ_loading = false
            }).catch(() => {
                this.liste_champ_loading = false
                this.is_error = true
            })
        },

        setChampToEdit(data) {
            this.champ_to_edit = data
            this.mdl_toggler = (this.mdl_toggler == 0)?1:0
            this.is_edit = true
            $('.add-mdl-examen').modal('show')
        },

        addChampModele() {
            this.champ_to_edit = {}
            this.mdl_toggler = (this.mdl_toggler == 0)?1:0
            this.is_edit = false
            $('.add-mdl-examen').modal('show')
        },
    }
}